"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveBuildingInvoiceConfigMutation = exports.useFetchBuildingInvoiceConfigQuery = exports.buildingInvoiceConfigApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.buildingInvoiceConfigApi = (0, react_1.createApi)({
    reducerPath: "buildingInvoiceConfigApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["buildingInvoiceConfig"],
    endpoints: function (builder) { return ({
        fetchBuildingInvoiceConfig: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId;
                return ({
                    url: "/v1/building-invoice-config/fetch",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId },
                });
            },
            providesTags: ["buildingInvoiceConfig"],
        }),
        saveBuildingInvoiceConfig: builder.mutation({
            query: function (body) { return ({
                url: "/v1/building-invoice-config/save",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["buildingInvoiceConfig"],
        }),
    }); },
});
exports.useFetchBuildingInvoiceConfigQuery = exports.buildingInvoiceConfigApi.useFetchBuildingInvoiceConfigQuery, exports.useSaveBuildingInvoiceConfigMutation = exports.buildingInvoiceConfigApi.useSaveBuildingInvoiceConfigMutation;
